import React, { useEffect ,useState} from "react";
import lunisolar from 'lunisolar'
import zhCn from 'lunisolar/locale/zh-cn'
import theGods from 'lunisolar/plugins/theGods'
import styles from  "./index.module.css";
lunisolar.locale(zhCn)
lunisolar.extend(theGods)
function Reminder() {
    const[act,setAct]=useState([])
    const[bad,setBad]=useState([])
    useEffect(() => {
        const lsr =  lunisolar(
          new Date().getTime(),
          {lang:'zhCn'}
        )
        const suitableList = lsr.theGods.query('good act 1')?.filter(item => item?.length  == 2);
        const taboosList = lsr.theGods.query('bad act 1')?.filter(item => item?.length  == 2);
        const suitable = suitableList?.length ? suitableList?.slice(0,3) : [];
        const taboos = taboosList?.length ? taboosList?.slice(0,3) : [];
        setAct(suitable)
        setBad(taboos)
    },[])
  return (
    <div className={styles['reminder-content']}>
      <div className={styles['reinder-item']} >
        <div className={styles['reminder-type']} >宜</div>
        <div className={styles['reminder-word']} >
          {
            act?.map(item => (<div className={styles['word-item']} key={item} >{item}</div>))
          }
        </div>
      </div>
      <div className={styles['reinder-item']} >
        <div className={[styles['reminder-type'],styles['reminder-special']].join(' ')} >忌</div>
        <div className={styles['reminder-word']} >
          {
            bad?.map(item => (<div className={styles['word-item']} key={item} >{item}</div>))
          }
        </div>
      </div>
    </div>
  );
}

export default Reminder;